import React from 'react';
import { Toggle } from '@itglue/kaseya-ui';

interface IProps {
    className?: string;
    label?: string;
    labelOff?: string;
    labelOn?: string;
    checked: boolean;
    onChange: () => void;
    disabled?: boolean;
    value?: boolean | string;
    id?: string;
}

export const PasslySwitch = (props: IProps) => {
    const { className, label, labelOff, labelOn,  checked, onChange, disabled } = props;

    return (
        <Toggle
            className={className}
            onToggle={onChange}
            on={checked}
            labelOff={labelOff ? labelOff : label}
            labelOn={labelOn ? labelOn : label}
            disabled={disabled}
        />
    );
};
